/**
 * Created by razial on 16.08.2024.
 */

AdventureExpedition.register_adventure4 = function () {
    Harvested.CONFIG.adventure4 = this.createExtendedHarvestedConfig();

    if (typeof AchievementsConfig !== "undefined") {
        AchievementsConfig.registerExpedition("adventure4", {
            fog: "fog1",
            force: Forces.LANDMARK_DONOR_SLOT2,
            donors: this.DONORS
        });
    }

    CustomerRecipes.adventure4 = this.CUSTOMER_RECIPES;

    Spawner.PRIZES.adventure4 = this.SPAWNER_PRIZES;

    Map2d.TILE_MATERIALS.adventure4 = this.TILE_MATERIALS;

    cleverapps.styles.adventure4 = {
        warehouseTutorialMinimal: this.WAREHOUSE_TUTORIAL_MINIMAL
    };
};
UnitsLibrary.CODES_BY_TAB.adventure4 = [
    [],
    [],
    [],
    ["advsource", "advgenerator0"],
    ["advprize", "expredchest"],
    []
];

cleverapps.styles.FogTileView["adventure4"] = cleverapps.styles.FogTileView["adventure"];